import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
} from "react";
import { Chart } from "react-google-charts";
import { ResponsiveSankey } from "@nivo/sankey";

import { Container, Box, Stack, Fab, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWindowDimensions } from "./useWindowDimensions.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";

import {
  faChevronLeft,
  faChevronRight,
  faCircleChevronLeft,
  faCircleChevronRight,
  faExpand,
} from "@fortawesome/free-solid-svg-icons";


import ToggleSet from "../Components/ToggleSet.jsx";
import { myOwnFP_chart_palette2 } from "../Components/Charts.jsx"

import { ErrorBar } from "../Components/ErrorBar.jsx";
import { HelpChart } from "../Dialogs/Help/Help_Charts.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";
import { SliderLabelled } from "../Components/Inputs/Sliders.jsx";
import { chevronColor, iconSize } from "./GridRenderers.jsx";
import CloseIcon from "../Components/CloseIcon.jsx";
import { ChartExportSankey } from "../Components/ChartExport.jsx";


const MyResponsiveSankey = forwardRef((props, ref) => {
  return (
    <ResponsiveSankey
      ref={ref}
      {...props}
    />
  );
});

const ChartSankey = ({
  clientJson,
  type,
  args,
  dataset,
  acct,
  onLeft = null,
  onRight = null,
  onClose,
  width = 1700,
  height = 800,
  onError,
  scen_name = null,
  onSetChange = null,
  dataSet_ = null,
  client_ = null,
  onYearChange = null,
  year_ = null,
  showDups = true,
}) => {
  const { winHeight, winWidth } = useWindowDimensions();
  const chartRef = useRef(null);

  const clientData = useRef(null);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState();
  const [dataSets, setDataSets] = useState([]);
  const [dataSet, setDataSet] = useState();
  const [year, setYear] = useState(0);


  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState();

  const [chartTitle, setChartTitle] = useState();
  const [chartSubtitle, setChartSubtitle] = useState();
  const [chartSeries, setChartSeries] = useState([]);
  const [chartAxes, setChartAxes] = useState();
  const [expand, setExpand] = useState(false);
  const [errmsg, setErrmsg] = useState("")





  const getData = () => {
    if (clientData.current && chartData && chartData.links.length > 0 && chartData.nodes.length > 0) {

      // console.log(chartData)
      // console.log(year)
      return chartData;

    }
    return {
      "nodes": [
        { "id": "empty_source" },
        { "id": "empty_target" }
      ],
      "links": [{
        "source": "empty_source",
        "target": "empty_target",
        "value": 0,
      }],
    }


  };

  const hasData = () => {
    return (clientData.current && chartData && chartData.links.length > 0 && chartData.nodes.length > 0) ? true : false
  }


  const gre_sankey_options = {
    sankey: {
      iterations: 2,
      link: { colorMode: 'gradient' },
      nodePadding: 10,


    },
  };


  const getOptions = () => {
    return gre_sankey_options;
  };

  const CheckIfData_ = (cl, ds) => {
    if (clientData.current && clientData.current[cl] && clientData.current[cl][ds] && clientData.current[cl][ds].DataSankey && clientData.current[cl][ds].DataSankey.Data) {
      return true
    }
    return false
  }


  const CheckIfData = () => {
    return CheckIfData_(client, dataSet)

  }

  const Update = (cl, ds) => {
    setClient(cl);
    setDataSet(ds);
    // console.log(cl + "  :  " + ds)
    if (CheckIfData_(cl, ds)) {
      // console.log("Have data")
      if (clientData.current[cl][ds].DataSankey.Data !== null) {
        // console.log("check year. y=" + year)
        let y = year

        if (y == 0) {
          y = clientData.current[cl][ds].DataSankey.MinYear
          if (onYearChange !== null) {
            // console.log("set min year =" + y)
            onYearChange(y)
          } else {
            setYear(y)
            UpdateYear(y)
          }
        }
        // check against the current clien/ds to keep the same data
        if (CheckIfData()) {
          if (!(y >= clientData.current[client][dataSet].DataSankey.MinYear && y <= clientData.current[client][dataSet].DataSankey.MaxYear)) {
            y = clientData.current[cl][ds].DataSankey.MinYear
            // console.log("reset the year")
          }
        }
        setChartData(clientData.current[cl][ds].DataSankey.Data[y]);
      }
      //setChartOptions(clientData.current[cl][ds].Options);


    } else {
      setYear(0)
      setChartData([]);
    }


  };

  const UpdateYear = (y) => {
    if (CheckIfData()) {
      setChartData(clientData.current[client][dataSet].DataSankey.Data[y]);
      //setChartOptions(clientData.current[client][dataSet].Options);


    }
  };

  const minYear = () => {
    if (CheckIfData()) {
      return clientData.current[client][dataSet].DataSankey.MinYear
    }
    return 0
  }


  const maxYear = () => {
    if (CheckIfData()) {
      return clientData.current[client][dataSet].DataSankey.MaxYear
    }
    return 0
  }
  const birthYear = () => {
    if (CheckIfData()) {
      let by = clientData.current[client][dataSet].DataSankey.BirthYear
      if (by > 1) {
        // console.log(by)
        return by
      }
    }
    console.log("no birthYear")
    return null
  }


  useEffect(() => {
    setErrmsg("")
    if (dataset !== null) {
      if (dataset.Clients !== null && dataset.DataSets !== null) {
        clientData.current = dataset.ClientData;
        setClients(dataset.Clients);
        setDataSets(dataset.DataSets);
        Update(dataset.Clients[0], dataset.DataSets[0]);
      }
    }
  }, [dataset]);

  useEffect(() => {
    Update(client_, dataSet_)
  }, [client_, dataSet_])

  useEffect(() => {
    if (year_ !== null) {
      setYear(year_)
      UpdateYear(year_)
    }
  }, [year_])



  const btnClientChanged = (value) => {
    console.log("chart client changed: " + value);
    if (onSetChange !== null) {
      onSetChange(value, dataSet)
    } else {
      Update(value, dataSet);
    }

  };

  const btnDataSetChanged = (value) => {
    console.log("chart dataset changed: " + value);
    if (onSetChange !== null) {
      onSetChange(client, value)
    } else {
      Update(client, value);
    }
  };


  const slide_Year = (e) => {
    //console.log(year)
    let y = e.target.value
    if (onYearChange !== null) {
      onYearChange(y)
    } else {
      setYear(y)
      UpdateYear(y)
    }
  }
  const formatter = new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    maximumFractionDigits: 0,
  })

  const RemoveExtraDots = (label) => {
    if (label[0] === '.') {
      label = label.substring(1)
    }
    if (label[label.length - 1] === '.') {
      label = label.substring(0, label.length - 1)
    }
    return label

  }




  const chartRefFn = () => {
    return chartRef
  }

  // console.log(chartRef)

  try {
    return (
      <Container maxWidth="true" sx={{ display: "flex", mx: 2, my: 2 }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} sx={{ alignContent: "center" }}>
            <div>
              <Stack direction="row" spacing={2}>
                <CrumbToggleScenario
                  key={"client-chartID-crTsk"}
                  set={clients}
                  current={client}
                  onChange={btnClientChanged}
                  clientJson={clientJson}
                  scen_name={scen_name}
                />
                <ToggleSet
                  key={"client-chartID-tssk"}
                  set={dataSets}
                  current={dataSet}
                  onChange={btnDataSetChanged}
                />

                {showDups && onLeft && (
                  <Stack direction="row">
                    <FontAwesomeIcon
                      color={chevronColor}
                      size="2xl"
                      icon={faCircleChevronLeft}
                      onClick={onLeft}
                    />
                  </Stack>
                )}
                {showDups && onRight && (
                  <Stack direction="row">
                    <FontAwesomeIcon
                      color={chevronColor}
                      size="2xl"
                      icon={faCircleChevronRight}
                      onClick={onRight}
                    />
                  </Stack>
                )}
              </Stack>
            </div>


            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                alignContent: "center",
                justifyContent: "flex-end",
              }}
            >

              <Stack direction="row" spacing={4}>
                {/* <ChartExportSankey
                  filename={"MyOwnFP " + (scen_name !== null ? scen_name : clientJson.Scenario.label) + " " + client + " " + dataSet + " " + year}
                  titleFn={getTitle}
                  chartRefFn={chartRefFn}
                /> */}
                <HelpIcon mt={-1}
                  show={showDups} />
                <Stack>
                  <Box sx={{ mt: 1, mr: 2 }}>
                    <FontAwesomeIcon
                      size={iconSize}
                      color="lightgray"
                      icon={faExpand}
                      onClick={() => setExpand(!expand)}
                    />

                  </Box>
                </Stack>
                <CloseIcon mt={-.5}
                  show={showDups}
                  onClick={onClose}
                />
              </Stack>
            </Box>
          </Stack>
          <Paper>
            <Box
              sx={{
                display: "flex",
                alignContent: "start",
                justifyContent: "start",
                mx: 10,
                my: 10,
                flexGrow: 1
              }}
            >
              <Stack spacing={2}>
                <Stack direction="row" spacing={0}>
                  <Typography
                    sx={{ alignContent: "begin" }}
                    variant="h5"
                    component="div"
                  >
                    Cash Flow
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexGrow: 1,
                      justifyContent: "center"
                    }}
                  >
                    <SliderLabelled
                      label="Year"
                      name="year"
                      value={year}
                      offset={birthYear()}
                      onChange={slide_Year}
                      min={dataset ? minYear() : 1960}
                      max={dataset ? maxYear() : 2080}

                    />
                  </Box>
                </Stack>

                {clientData.current && (
                  <Box sx={{
                    width: expand ? winWidth - 66 * 4 : width,
                    height: expand ? winHeight - 65 * 4 : height,
                  }}>
                    {hasData() && (

                      <MyResponsiveSankey
                        ref={chartRef}
                        data={getData()}
                        enableLinkGradient={true}
                        linkOpacity={0.5}
                        linkHoverOthersOpacity={0.45}
                        align="justify"
                        nodeOpacity={1}
                        nodeHoverOthersOpacity={0.35}
                        nodeBorderWidth={2}
                        nodeThickness={15}
                        nodeSpacing={44}
                        nodeBorderRadius={5}
                        nodeInnerPadding={0}
                        nodeBorderColor="white"
                        animate={false}
                        motionConfig="molasses"
                        colors={node => node.nodeColor}
                        labelTextColor={{
                          from: 'black',
                          modifiers: [
                            [
                              'darker',
                              1.9
                            ]
                          ]
                        }}
                        theme={{
                          text: {
                            fontSize: 13
                          }
                        }}
                        label={node => `${RemoveExtraDots(node.id)}: ${formatter.format(node.value)}`}
                        margin={{
                          bottom: 10,
                          top: 10,
                        }}
                      />
                    )}
                    {!hasData() && (

                      <Box sx={{ display: "flex", justifyContent: "center", flexGrow: 1 }}>
                        <Typography
                          variant="h6"
                          component="div"
                        >
                          No cash flow for this year
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}
                <ErrorBar error={errmsg} />
                <HelpChart chart={type} arg={args} />
              </Stack>
            </Box>
          </Paper>
        </Stack>
      </Container >
    );
  } catch (e) {
    return <div>Hmm! That shouldn't have happened. Please return to the login page and sign in again.</div>;
  }
};

export default ChartSankey;
